module.exports = __webpack_public_path__ + "static/media/lds-logo_sv.17c2923b.svg";